<template>
  <nav
    class="navbar is-primary no-print"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <router-link class="navbar-item" to="/">
        <!-- <img src="@/assets/logo.png" width="30" height="30"> -->
        <span>&nbsp;&nbsp;{{ this.user.username }}</span>
      </router-link>
      <a
        role="button"
        class="navbar-burger"
        aria-label="menu"
        aria-expanded="false"
        :class="{ 'is-active': isMenuActive }"
        @click="isMenuActive = !isMenuActive"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div class="navbar-menu" :class="{ 'is-active': isMenuActive }">
      <div class="navbar-start">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>Checker</span>
          </a>

          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/marketmanager/checkerproduct"
              :exact="true"
              active-class="is-active"
            >
              <span>ສິນຄ້າເຂົ້າອອກຕະຫຼາດ</span>
            </router-link>
          </div>
        </div>

        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ຕັ້ງຄ່າສິນຄ້າ</span>
          </a>

          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/marketmanager/recommendproduct"
              :exact="true"
              active-class="is-active"
            >
              <span>ສິນຄ້າຂາຍດີ ແລະ ສິນຄ້າແນະນຳ</span>
            </router-link>
          </div>
        </div>
      </div>

      <div class="navbar-end">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ຕັ້ງຄ່າຕ່າງໆ</span>
          </a>
          <div class="navbar-dropdown">
            <!-- <router-link
              v-if="roleid == '22'"
              @click.native="menuClicked"
              class="navbar-item"
              to="/marketmanager/marketcheckproduct"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການ Checker</span>
            </router-link>

            <router-link
              v-if="roleid == '22'"
              @click.native="menuClicked"
              class="navbar-item"
              to="/dasm/setting/branch"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການສາຂາ...</span>
            </router-link>

            <router-link
              v-if="roleid == '22' || roleid == '23'"
              @click.native="menuClicked"
              class="navbar-item"
              to="/dasm/setting/market"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການຕະຫຼາດ</span>
            </router-link> -->

            <router-link
              v-if="roleid == '22' || roleid == '23'"
              @click.native="menuClicked"
              class="navbar-item"
              to="/marketmanager/rider"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການ Rider</span>
            </router-link>

            <!-- <router-link
              v-if="roleid == '6' || roleid == '7'"
              @click.native="menuClicked"
              class="navbar-item"
              to="/dasm/setting/shippingfee"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການຄ່າສົ່ງ</span>
            </router-link> -->
          </div>
        </div>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ຜູ້ໃຊ້ງານ</span>
          </a>
          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/form/userProfile"
              :exact="true"
              active-class="is-active"
            >
              <span>ຂໍ້ມູນສ່ວນຕົວ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/login"
              :exact="true"
              active-class="is-active"
            >
              <span>ອອກຈາກລະບົບ</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "ReportMenu",
  data() {
    return {
      isMenuActive: false,
      roleid: null,
    };
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    // console.log("roleid: "+ JSON.stringify(this.roleid))
  },
  computed: {
    // user: get("loginData"),
  },
  methods: {
    menuClicked() {
      this.isMenuActive = false;
    },
  },
};
</script>

<style scoped>
.navbar-item {
  white-space: nowrap;
}
.navbar-end {
  padding-right: 60px;
}
</style>
